import { render, staticRenderFns } from "./LeftMenuItem.vue?vue&type=template&id=963cdb32&"
import script from "./LeftMenuItem.vue?vue&type=script&lang=ts&"
export * from "./LeftMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./LeftMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports